import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'next/image';
import TextInput from '@hiredigital/ui/Input/SimpleTextInput';
import Button from '@hiredigital/ui/Button/Button';

import Text from '@hiredigital/ui/Text/Text';
import { Section, SectionContainer } from '@components/Section';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';
import Styles from './JobDescriptionCta.module.scss';

const JobDescriptionCta = ({ title, description, analyticsData }) => {
  return (
    <SectionContainer className={classNames(Styles.jdCallToActionContainer)} anchor='cta'>
      <Section className={classNames(Styles.jdCallToActionSection)}>
        <div className={Styles.jdCallToActionSubSec}>
          <Text className={Styles.jdCallToActionTitle}>{title}</Text>
          <Text className={Styles.jdCallToActionDescription}>{description}</Text>
          <InteractiveButton
            className={Styles.jdCallToActionButton}
            type={Button.Type.BLUE}
            title='Get Started'
            href={{
              pathname: `/get-started`,
              query: { ...analyticsData },
            }}>
            Get Started
          </InteractiveButton>
        </div>
        <div className={Styles.jdCallToActionImageContainer}>
          <Image
            className={Styles.jdCallToActionImage}
            src={`/img/case-studies/cta-image.webp`}
            alt='Job Description CTA Image'
            fill
          />
        </div>
      </Section>
    </SectionContainer>
  );
};

JobDescriptionCta.propTypes = {
  title: PropTypes.string,
  buttonLabel: PropTypes.string,
  description: PropTypes.string,
  linkTo: PropTypes.string,
  className: PropTypes.string,
};

export default JobDescriptionCta;
